import {Button, Col, Form, Image, Input, Row, Tag, Typography} from "antd";
import {SearchOutlined} from "@ant-design/icons";
import React, {useEffect, useState} from "react";
import {Modal, useOpenModal} from '@/components/Modal/index.mjs'
import runAsync from "@/script/runAsync.mjs";
import FileUtils from "@/script/FileUtils";
import useHTTP from "@/hooks/useHTTP.mjs";
import Table from "@/biz/Table";

const {CheckableTag} = Tag
const {Text, Paragraph} = Typography
const fallbackImage = "data:image/png;base64,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"

const formCss = {
    '& .ant-form-item': {
        marginBottom: '12px'
    }
}

/**
 * 选择用户界面布局类型弹窗
 * @param onOk
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
export default function SelectUmUiLayoutTypeDialog({onOk, multiple = true, ...props}) {
    const http = useHTTP();
    const openModal = useOpenModal();

    // 表单
    const [form] = Form.useForm();
    // 数据模型
    const [data, setData] = useState([]);

    // 加载显示
    const [loading, setLoading] = useState(false);
    const columns = [
        {
            title: '布局图',
            dataIndex: 'previewFileId',
            width: 80,
            render: (text) => {
                return <Image
                    width={46}
                    src={FileUtils.getFileUrl(text)}
                    fallback={fallbackImage}
                />
                // return <img src={FileUtils.getFileUrl(text)} style={{width: '24px', height: '24px', objectFit: 'contain'}}/>
            }
        },
        {
            title: '界面类型代码',
            dataIndex: 'layoutTypeCode',
            width: 180,
            filter: <Table.FilterText/>,
        },
        {
            title: '界面类型名称',
            dataIndex: 'layoutTypeName',
            width: 180,
            ellipsis: true,
            filter: <Table.FilterText/>,
            // render: (text, record) => {
            //     return (
            //         <a
            //             onClick={() => handleModifyClick(record)}
            //         >
            //             {text}
            //         </a>
            //     )
            // },
        },
        // {
        //     title: '默认视图模板',
        //     dataIndex: 'defaultUvTemplateName',
        //     width: 160,
        //     ellipsis: true,
        //     filter: <Table.FilterText/>,
        // },
        // {
        //     title: '支持生成界面原型',
        //     dataIndex: 'supportGenerateUv',
        //     width: 160,
        //     ellipsis: true,
        //     filter: <Table.FilterText getText={value => value === '1' ? '是' : '否'}/>,
        // },
        // {
        //     title: '支持生成前端源码',
        //     dataIndex: 'supportGenerateUiSrouceCode',
        //     width: 160,
        //     ellipsis: true,
        //     filter: <Table.FilterText getText={value => value === '1' ? '是' : '否'}/>,
        // },
        // {
        //     title: '排序号',
        //     dataIndex: 'seqNo',
        //     width: 80,
        //     filter: <Table.FilterNumber/>,
        // },
    ];
    const [selectedRows, setSelectedRows] = useState([]); // 选中的对象集合
    const rowSelection = {
        type: multiple ? 'checkbox' : 'radio',
        selectedRowKeys: selectedRows.map(({pkid}) => pkid),
        onChange: (selectedRowKeys, selectedRows) => {
            setSelectedRows(selectedRows);
        },
    }

    const doQuery = async () => {
        try {
            setLoading(true);
            const data = await runAsync(
                async () => {
                    return await http.get(`/umUiLayoutType/listEnableUmUiLayoutType`, form.getFieldsValue());
                }, {
                    error: {content: (err) => `查询失败: ${err.message}`},
                    loading: {show: false},
                    success: {show: false},
                });
            setData(data);
            setSelectedRows([])
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    }

    const handleOkClick = async () => {
        if (multiple) {
            onOk(selectedRows.map(v => { return { ...v, layoutTypeId: v.pkid } }));
        } else {
            if (selectedRows.length > 0) {
                const result = selectedRows[0];
                onOk({ ...result, layoutTypeId: result.pkid });
            }
        }
    }

    useEffect(() => {
        doQuery()
    }, [])

    return (
        <Modal
            title={"选择界面类型"}
            width={1280}
            style={{top: 20}}
            bodyStyle={{overflow: 'hidden', display: 'flex', flexDirection: 'column', height: '80vh', minHeight: 320, background: '#fff', padding: 0, gap: 12,}}
            onOk={handleOkClick}
            {...props}
        >
            {/* 查询条件 */}
            <div style={{padding: '12px 24px 0 24px', background: '#fff'}}>
                <Form form={form} onFinish={doQuery} css={formCss}>
                    <Row gutter={12}>
                        <Col span={6}>
                            <Form.Item name="layoutTypeCode" label="界面类型代码">
                                <Input allowClear/>
                            </Form.Item>
                        </Col>
                        <Col span={6}>
                            <Form.Item name="layoutTypeName" label="界面类型名称">
                                <Input allowClear/>
                            </Form.Item>
                        </Col>
                        <Col span={6} offset={6} style={{textAlign: 'right'}}>
                            <Button onClick={() => form.resetFields()} style={{margin: '0 8px'}}>重置</Button>
                            <Button type="primary" htmlType="submit" icon={<SearchOutlined/>}>查询</Button>
                        </Col>
                    </Row>
                </Form>
            </div>

            {/* 数据表格 */}
            <div style={{display: 'flex', flexDirection: 'column', flexGrow: '1', overflow: 'hidden', padding: '12px 24px', background: '#fff',}}>
                <Table
                    code='select-um-ui-layout-type-dialog-list'
                    loading={loading}
                    dataSource={data}
                    rowKey={'pkid'}
                    rowSelection={{ ...rowSelection}}
                    columns={columns}
                    onRow={(record) => ({
                        onClick: () => {
                            if (!multiple) {
                                setSelectedRows([record]);
                            }
                        },
                    })}
                />
            </div>
        </Modal>
    )
}

